export enum FirmwareRoutes {
    FirmwareList = 'list'
}
